import type { tBootArm, tBootOutcome, tTokenlessAuthOutcome } from 'src/firebase/bootSession';

export const SESSION_EVENTS = {
  BOOT_AUTH_PENDING: 'front.session.boot_auth_pending',
  BOOT_AUTH_RESOLVED: 'front.session.boot_auth_resolved',
  BOOT_AUTH_SETTLED: 'front.session.boot_auth_settled',
  BOOT_DATA_READY: 'front.session.boot_data_ready',
  FORCED_SIGN_OUT: 'front.session.forced_sign_out',
} as const;

export type tBootProperties = { boot_id: string; auth_hold_arm: tBootArm };
type tTokenlessRequestDiagnostics = {
  request_diagnostics_version: 1;
  tokenless_requests_by_auth_outcome: Partial<Record<tTokenlessAuthOutcome, number>>;
  first_tokenless_request_ms_since_navigation_start?: number;
  first_tokenless_request_auth_outcome?: tTokenlessAuthOutcome;
};
export type tSessionEventProperties = {
  [SESSION_EVENTS.BOOT_AUTH_PENDING]: {
    mirror_state: 'absent' | 'expired' | 'unreadable';
    navigation_type: string;
    prerendered: boolean;
    tab_document_ordinal: number;
    visibility_state: DocumentVisibilityState;
    route_group: string;
    ms_since_navigation_start: number;
  };
  [SESSION_EVENTS.BOOT_AUTH_RESOLVED]: {
    outcome: tBootOutcome;
    held_ms: number;
    visibility_state: DocumentVisibilityState;
    was_hidden_during_hold: boolean;
  };
  [SESSION_EVENTS.BOOT_AUTH_SETTLED]: tTokenlessRequestDiagnostics & {
    settle_ms: number;
    settled_with_user: boolean;
    firebase_calls: { host: string; duration: number }[];
    tokenless_requests: number;
    degraded_401s: number;
  };
  [SESSION_EVENTS.BOOT_DATA_READY]: tTokenlessRequestDiagnostics & {
    ms_since_navigation_start: number;
    attempts: number;
    tokenless_requests: number;
    degraded_401s: number;
  };
  [SESSION_EVENTS.FORCED_SIGN_OUT]: tTokenlessRequestDiagnostics & {
    carried_token: boolean;
    tokenless_requests: number;
    degraded_401s: number;
    endpoint: string;
    /** The signOut branch was selected; not a promise that the SDK completed. */
    firebase_sign_out_called: boolean;
  };
};
